import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Params, Router} from '@angular/router';
import {AppAuthService, InvoiceService} from '../service';
import {InvoiceListResolver} from './invoice-list.resolver';
import {mergeMap, Observable, of} from 'rxjs';
import {Invoice, Page} from '../../model';
import {take} from 'rxjs/operators';

@Injectable()
export class InvoiceListForCustomerResolver extends InvoiceListResolver {
  constructor(router: Router, service: InvoiceService, auth: AppAuthService) {
    super(router, {
      ...service,
      list(queryParams: Params): Observable<Page<Invoice>> {
        return auth.isAdmin$.pipe(
          take(1),
          mergeMap((admin) => admin
            ? service.list(queryParams)
            : of({} as any)
          ));
      }
    } as InvoiceService);
  }

  override updateParameter(route: ActivatedRouteSnapshot): Params {
    const {id: customer} = route.params;
    return {...super.updateParameter(route), customer};
  }

  protected override mapStatus(status?: string): string | undefined {
    return super.mapStatus(status || 'ALL');
  }
}
